// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Tab from "@insite/mobius/Tab/Tab";
import TabGroup from "@insite/mobius/TabGroup/TabGroup";
import { SectionContainer } from "@pace/App/Widgets/DesignSystem/DesignSystem.helpers";
import { customXngageWidget } from "@pace/XDL/constants";
import React, { FC } from "react";
import { css } from "styled-components";

interface TabsStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
}

const tabsStyles: TabsStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
};

const styles = tabsStyles;

const enum tabFields {
    title = "title",
}

const enum fields {
    tabs = "tabs",
}

interface TabField {
    fields: {
        [tabFields.title]: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.tabs]: TabField[];
    };
}
type Props = OwnProps;

const XTabs: FC<Props> = ({ fields: { tabs = [] }, id }) => {
    return (
        <SectionContainer>
            <GridItem {...styles.gridItem}>
                <TabGroup>
                    {tabs.map((tab, index) => (
                        <Tab
                            key={tab.fields.title}
                            headline={tab.fields.title}
                            tabKey={tab.fields.title}
                            aria-label={`${tab.fields.title} tab`}
                        >
                            <Zone contentId={id} zoneName={`content_${index}`} />
                        </Tab>
                    ))}
                </TabGroup>
            </GridItem>
        </SectionContainer>
    );
};
const xTabWidget: WidgetModule = {
    component: XTabs,
    definition: {
        group: customXngageWidget as any,
        fieldDefinitions: [
            {
                editorTemplate: "ListField",
                name: fields.tabs,
                getDisplay: (item: any) => item.fields.title,
                defaultValue: [],
                fieldType: "General",
                validate: (value, item) => {
                    if(value.length > 5){
                        return translate(`You Can't add more than 5 tabs`);
                    }
                    return null;
                },
                fieldDefinitions: [
                    {
                        name: tabFields.title,
                        editorTemplate: "TextField",
                        displayName: "Title",
                        isRequired: true,
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};
export default xTabWidget;
